//nouns with irregular plural/singular forms
//used in noun.inflect, and also in the lexicon.
//compressed with '_' to reduce some redundancy.
var main=[
    ["child", "_ren"],
    ["person", "people"],
    ["leaf", "leaves"],
    ["database", "_s"],
    ["quiz", "_zes"],
    ["child", "_ren"],
    ["stomach", "_s"],
    ["sex", "_es"],
    ["move", "_s"],
    ["shoe", "_s"],
    ["goose", "geese"],
    ["phenomenon", "phenomena"],
    ["barracks", "_"],
    ["deer", "_"],
    ["syllabus", "syllabi"],
    ["index", "indices"],
    ["appendix", "appendices"],
    ["criterion", "criteria"],
    ["man", "men"],
    ["sex", "_es"],
    ["rodeo", "_s"],
    ["epoch", "_s"],
    ["zero", "_s"],
    ["avocado", "_s"],
    ["halo", "_s"],
    ["tornado", "_s"],
    ["tuxedo", "_s"],
    ["sombrero", "_s"],
    ["addendum", "addenda"],
    ["alga", "_e"],
    ["alumna", "_e"],
    ["alumnus", "alumni"],
    ["bacillus", "bacilli"],
    ["cactus", "cacti"],
    ["beau", "_x"],
    ["château", "_x"],
    ["chateau", "_x"],
    ["tableau", "_x"],
    ["corpus", "corpora"],
    ["curriculum", "curricula"],
    ["echo", "_es"],
    ["embargo", "_es"],
    ["foot", "feet"],
    ["genus", "genera"],
    ["hippopotamus", "hippopotami"],
    ["larva", "_e"],
    ["libretto", "libretti"],
    ["loaf", "loaves"],
    ["matrix", "matrices"],
    ["memorandum", "memoranda"],
    ["mosquito", "_es"],
    ["opus", "opera"],
    ["ovum", "ova"],
    ["ox", "_en"],
    ["radius", "radii"],
    ["referendum", "referenda"],
    ["thief", "thieves"],
    ["tooth", "teeth"]
  ]

  main = main.map(function (a) {
    a[1] = a[1].replace('_', a[0])
    return a
  })

module.exports = main;



//////////////////
// WEBPACK FOOTER
// ./~/nlp_compromise/src/data/lexicon/irregular_nouns.js
// module id = 190
// module chunks = 0